module.exports = __webpack_public_path__ + "img/1701395768368-WhatsApp Image 2023-12-01 at 09.33.11.jpeg.962ed04f.webp";